// eslint-disable-next-line no-unused-vars
const jsdocTypes = require('../../../../../jsdoc-types');

const {
  getDoubleLookPIDWithoutSize,
} = require('../../common/utils/doubleLookUtils');
const { isEmpty } = require('../../common/utils/type');

const itemList = require('../stores/itemList');
const { buildItemListForProductTileContext } = require('./itemListHelpers');

/**
 * Build the item list and the position from the context of the tile, or use
 * some defined fallbacks
 * @param {Object} params Params to build
 * @param {string} params.productId The ID of the product
 * @param {jsdocTypes.BaseProductTileContext} [params.tileContext] The context
 *  of the tile from the product was added to cart
 * @param {number} [params.tilePosition] The position (index) of the tile
 * @returns {itemList.ItemListAndPosition} The list and position object
 */
function buildItemListAndPositionForJustAddedToCartProduct({
  productId,
  tileContext,
  tilePosition,
}) {
  let itemListAndPosition;
  let list;

  if (tileContext) {
    /*
     * This code is for the lists that can be built from tile context.
     * Examples: QuickShop from sliders or search
     * Other cases, will be responsability of another modules as
     * - ItemList tracking
     * - Fallback Item List when creating the GA4 items
     */
    list = buildItemListForProductTileContext(tileContext);
  }

  if (isEmpty(list)) {
    itemListAndPosition = itemList.clickedItemListStorage.getItem(
      getDoubleLookPIDWithoutSize(productId)
    );
    list = itemListAndPosition?.list ?? itemList.getFallbackItemList();
  }

  if (!itemListAndPosition) {
    itemListAndPosition = itemList.createItemListAndPosition(
      list,
      tilePosition
    );
  }

  return itemListAndPosition;
}

module.exports = {
  buildItemListAndPositionForJustAddedToCartProduct,
};
